import { Navigate, Outlet } from "react-router-dom";
import { AlertTriangle, RefreshCw } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Loading } from "@/components/common";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute() {
  const { session, me, loading, error, errorStatus, reload, signOut, configured } = useAuth();
  if (loading) return <Loading label="Loading your workspace" />;
  if (!configured || !session) return <Navigate to="/login" replace />;
  if (!me && !error) return <Loading label="Loading your workspace" />;
  if (me) return <Outlet />;
  const temporary = !errorStatus || errorStatus >= 500;
  return <main className="grid min-h-screen place-items-center px-5">
    <section className="panel max-w-md space-y-4 p-6" aria-labelledby="workspace-error-title" data-testid="account-blocked">
      <AlertTriangle className="h-6 w-6 text-muted-foreground" aria-hidden />
      <h1 id="workspace-error-title" className="font-display text-xl font-semibold">We can't open your workspace</h1>
      <p className="text-sm text-muted-foreground" role="alert">
        {temporary ? "Your workspace service is temporarily unavailable. Your session is saved. Check your connection and try again." : error}
      </p>
      {temporary && <p className="text-xs text-muted-foreground">We'll retry while this tab is open and when your connection returns.</p>}
      <div className="flex flex-wrap gap-2">
        <Button onClick={reload} data-testid="workspace-retry"><RefreshCw className="mr-2 h-4 w-4" aria-hidden />Try again</Button>
        <Button variant="outline" onClick={signOut} data-testid="blocked-sign-out">Sign out</Button>
      </div>
    </section>
  </main>;
}
